import script from "./providerCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./providerCard.vue?vue&type=script&setup=true&lang=ts"

import "./providerCard.vue?vue&type=style&index=0&id=d448fa84&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d448fa84"]])

export default __exports__